import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_PAGINGAPPLICATIONSCAREPROVIDER_FULFILLED = "FETCH_PAGINGAPPLICATIONSCAREPROVIDER_FULFILLED";
export const FETCH_PAGINGAPPLICATIONSCAREPROVIDER_REJECTED = "FETCH_PAGINGAPPLICATIONSCAREPROVIDER_REJECTED";
export const FETCH_PAGINGAPPLICATIONSCAREPROVIDER_PENDING = "FETCH_PAGINGAPPLICATIONSCAREPROVIDER_PENDING";
export const RESET_PAGINGAPPLICATIONSCAREPROVIDER = "RESET_PAGINGAPPLICATIONSCAREPROVIDER"

export function pagingApplicationsCareProvider(pageSize, pageNumber) {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_PAGINGAPPLICATIONSCAREPROVIDER",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v3/second-opinion/paging-application-care-provider?pageSize=${pageSize}&pageNumber=${pageNumber}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "multipart/form-data",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data), 
        });
    };
}

export function resetPagingApplicationsCareProvider() {
    return (dispatch) => {
        dispatch({
            type: "RESET_PAGINGAPPLICATIONSCAREPROVIDER",
        });
    };
}




